import { Outlet } from "react-router-dom";
import AdminHeader from "./adminHeader";
import AdminFooter from "./adminFooter";
import SideBar from "./sideBar";

export default function AdminLayout() {
    return (
        <div className="min-h-screen bg-gray-100 text-gray-900 font-lato">
            <aside className="hidden lg:block fixed inset-y-0 left-0 z-20 w-64">
                <SideBar />
            </aside>
            <AdminHeader />
            <div className="lg:pl-64 flex min-h-screen flex-col">
                <main className="flex-1 w-full max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6 lg:py-10">
                    <Outlet />
                </main>
                <AdminFooter />
            </div>
        </div>
    )
}
